// import CardGiftcardIcon from '@mui/icons-material/CardGiftcard';
// import CurrencyExchangeIcon from '@mui/icons-material/CurrencyExchange';
// import LockIcon from '@mui/icons-material/Lock';
import PersonIcon from '@mui/icons-material/Person';
import SecurityIcon from '@mui/icons-material/Security';
import SyncAltIcon from '@mui/icons-material/SyncAlt';
import HistoryIcon from '@mui/icons-material/History';
import BadgeIcon from '@mui/icons-material/Badge';
// import { AccountBox } from '@mui/icons-material';
// import GroupsIcon from '@mui/icons-material/Groups';
// import LoyaltyIcon from '@mui/icons-material/Loyalty';
// import { isProduction } from '@/utils/checkRuntime';
import { isTelegramMiniAppView, isWoWSpaceView } from '@/utils/checkRuntime';
import { getStaticAsset } from '@/utils/staticAsset';
import { Share2 } from 'lucide-react';

const iconStyle = {
  color: 'currentColor',
  fontSize: '1.5rem',
};

const getProfileMenuConfigs = (t) =>
  [
    {
      icon: <PersonIcon style={iconStyle} />,
      path: '/profile/general',
      name: t('profile'),
    },
    {
      icon: <Share2/>,
      path: '/profile/referral',
      name: t('referral'),
    },
    {
      icon: <SecurityIcon style={iconStyle} />,
      path: '/profile/security',
      name: t('security'),
      hidden: isTelegramMiniAppView,
    }, // {
    //   icon: <CardGiftcardOutlined style={iconStyle} />,
    //   path: '/benefits/deposit',
    //   name: t('Bonus Pack'),
    //   hidden: isProduction,
    // },
    // {
    //   icon: <LoyaltyIcon />,
    //   path: '/profile/rewards',
    //   name: t('Rewards'),
    // },
    {
      icon: <SyncAltIcon style={iconStyle} />,
      path: '/profile/transactions',
      name: t('transactions'),
    }, // {
    //   icon: <ChildCareIcon />,
    //   path: '/profile/responsible-gaming',
    //   name: t('Responsible Gaming'),
    // },
    {
      icon: <HistoryIcon style={iconStyle} />,
      path: '/profile/login-history',
      name: t('login-history'),
    },
    {
      icon: <BadgeIcon style={iconStyle} />,
      path: '/profile/verify',
      name: t('verification'),
      hidden: isWoWSpaceView,
    },
  ].filter((item) => !item?.hidden);

export default getProfileMenuConfigs;
